module.exports = __webpack_public_path__ + "img/川乌.5926535e.jpg";